import { DefaultAnalyticsSettings } from 'analytics-api';

/**
 * Función encargada de rellenar los campos obligatorios del objeto de analítica pasado a GTM
 * @param event Tipo de evento (Ej: pageview)
 * @param cf Cf del evento (Ej: catalogo)
 * @param category Categoría dentro de la que se clasifica el evento (Ej: home)
 * @param action String que describe la acción que lanzar el evento (Ej: ver_producto)
 * @param label Etiqueta puesta al evento, no todos los eventos la llevan por lo que es opcional
 * @return Objeto de tipo DefaultAnalyticsSettings con los campos obligatorios rellenos
 */
export const getDefaultAnalytics = (event: string, cf: string, category: string, action: string, label?: string): DefaultAnalyticsSettings => {
  return {
    event,
    eventData: {
      cf,
      category,
      action,
      label: label ?? undefined
    }
  };
};

/**
 * Función encargada de rellenar los campos obligatorios del objeto de analítica para los page views
 * @param event Tipo de evento (Ej: pageview)
 * @return Objeto de tipo DefaultAnalyticsSettings con los campos obligatorios rellenos
 */
export const getDefaultPageView = (event: 'pageview' | 'popupview'): DefaultAnalyticsSettings => {
  return {
    event
  };
};
